/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrderReceiptItemDto { 
    discountAmount?: number;
    discountPercentage?: number;
    instructions?: string;
    name?: string;
    orderItemId?: number;
    price?: number;
    printQuantity?: number;
    quantity?: number;
    setItem?: string;
    skuNo?: string;
    total?: number;
    variant?: string;
}

